import { getInsuranceMemberIdPrefix } from "@/shared/models/insurance-evidence";
import type { AthenaCoverageReadbackOutput } from "@/src/lib/workflows/steps/step-outputs";

export function getInsuranceDecisionCoverage(coverage: AthenaCoverageReadbackOutput): {
  insuranceId: string;
  insurancePackageId: string;
  selfPay: boolean;
  memberIdPrefix: string | null;
} {
  const policy =
    !coverage.primary.casePolicy && coverage.secondary?.casePolicy
      ? { ...coverage.secondary, selfPay: false }
      : coverage.primary;
  const snapshot = coverage.coverages.find(
    (recorded) =>
      recorded.insuranceId === policy.insuranceId && recorded.insurancePackageId === policy.insurancePackageId
  );

  return { ...policy, memberIdPrefix: getInsuranceMemberIdPrefix(snapshot?.subscriberId) };
}
